/**
 * External dependencies
 */
import React from 'react';
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import NavListLink from './nav-list-link';

const NavListItem = ({ children, onClick, suffix, label, path, active }) => {
	const classes = classnames('nav-list__item');

	return (
		<li className={classes}>
			<NavListLink onClick={onClick} suffix={suffix} label={label} path={path} active={active} />
			{children}
		</li>
	);
};

export default NavListItem;
